import { render } from "./RolesViews.vue?vue&type=template&id=f5942654&scoped=true"
import script from "./RolesViews.vue?vue&type=script&lang=js"
export * from "./RolesViews.vue?vue&type=script&lang=js"

import "./RolesViews.vue?vue&type=style&index=0&id=f5942654&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5942654"]])

export default __exports__